import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('banksIntegrated', {
  customKeys: {
    list: 'banks',
  },
  customEndpoints: {
    list: '/banks/integrated',
  },
});
